import React, {useContext, useMemo, useRef, useState} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {useQuery} from "@tanstack/react-query";
import roleService from "../../../../../services/web/role-service.js";
import {RoleContext} from "../context/role-context.jsx";

const RoleModalPrograms = ({open, setOpen, rowPermission}) => {
    const {protectionProgramSelected, setProtectionProgramSelected} = useContext(RoleContext);

    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {headerName: "Programa", field: "name", flex: 1}
    ]);

    const {data} = useQuery({
        queryFn: () => roleService.programs(),
        queryKey: ["programs"]
    });

    const rowSelection = useMemo(() => {
        return {
            mode: "multiRow",
            headerCheckbox: true,
            enableClickSelection: false,
        };
    }, []);

    const defaultColDef = useMemo(() => {
        return {
            filter: true,
            floatingFilter: true,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true,
            suppressHeaderContextMenu: true,
            suppressFloatingFilterButton: true,
        };
    }, []);

    const onFirstDataRendered = ({api}) => {
        api.forEachNode(row => {
            const {id} = row.data;
            row.setSelected(protectionProgramSelected.includes(id));
        });
    };

    const confirm = () => {
        const selectedNodes = gridRef.current.api.getSelectedNodes();
        setProtectionProgramSelected(selectedNodes.map(node => node.data.id));

        setOpen(false);
    }

    return (
        <Modal open={open} setOpen={setOpen} title={"Programas de proteção"} className={"w-8/12"} isCloseClick={false}>
            <Modal.Body>
                <div style={{height: "calc(100vh - 300px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={data ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        rowSelection={rowSelection}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        suppressRowVirtualisation={true}
                        suppressColumnVirtualisation={true}
                        theme={aggridUtils.generalTheme()}
                        onFirstDataRendered={onFirstDataRendered}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={confirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RoleModalPrograms;